import CIMSBadge from 'components/CIMSBadge'
import { CIMSBadgeProps } from 'components/CIMSBadge/types'
import { Connection } from '../../../../../PayItemsModuleContext/types'

const ConnectionMenuItem: React.FC<Connection & CIMSBadgeProps> = ({
  googleSheet,
  id,
  name,
  count = 0,
}) => {
  let label = id
  if (googleSheet) label = googleSheet.title ?? googleSheet.compositeId
  if (name) label = name
  if (count > 0) return <CIMSBadge count={count}>{label}</CIMSBadge>
  return <>{label}</>
}

export default ConnectionMenuItem
